import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { Outlet, useNavigate } from "react-router-dom";
import { useHomeOutletContext } from "../../layout/useHomeOutletContext.ts";
import DiagnosticDialog from "../common/diagnostics/DiagnosticDialog.tsx";

export default function MyCoursesLayout() {
  const { isSidebarExpandable, onSidebarToggle } = useHomeOutletContext();
  const brand = useBrandLoaderData();
  const navigate = useNavigate();

  if (!brand.MyCourses.enabled) {
    void navigate("/");
  }

  return (
    <>
      <Outlet context={{ isSidebarExpandable, onSidebarToggle }} />
      <DiagnosticDialog />
    </>
  );
}
